/**
 * Props for a control that opens a lazily-loaded modal: they start its chunk downloading on the
 * first sign the user is heading for it, so the click usually lands on an already-cached module
 * and never sees the skeleton.
 *
 * Pointer-enter and focus between them cover mouse, keyboard and (via the synthetic pointer event
 * browsers fire before a tap) touch. Repeat calls are free — the underlying dynamic import
 * resolves from the module cache.
 *
 * @example
 * <Button onClick={openDeposit} {...preloadOnIntent(preloadDepositModal)}>Deposit</Button>
 */
export const preloadOnIntent = (preload: () => void) => ({
  onPointerEnter: preload,
  onFocus: preload,
});
